<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页
    </div>
    <div class="content-info">
      <div class="content-info-title">申报管理</div>
      <div class="step-box">
        <div class="speed-box" :class="{active1:status>1,active2:status>=2,active3:status>=3,active4:status>=3}">
          <div class="speed-item " :class="{active:status>1}">
            <i class="iconfont iconrenyuan"></i>
            <p>机构信息</p>
          </div>
          <div class="speed-item" :class="{active:status>=2}">
            <i class="iconfont iconweidian"></i>
            <p>制作微店</p>
          </div>
          <div class="speed-item" :class="{active:status>=3}">
            <i class="iconfont iconshenbao"></i>
            <p>项目申报</p>
          </div>
          <div class="speed-item" :class="{active:status>=3}">
            <i class="iconfont iconshenhetongguo"></i>
            <p>审核通过</p>
          </div>
        </div>
        <div class="index-info">
          <div class="index-info-item">
            <div class="content-info-title">公益慈善汇展</div>
            <div class="index-router">
              <div class="index-router-item"><span><i class="iconfont iconrenyuan"></i>基本信息</span> <router-link to="/home/orgInfo">查看</router-link></div>
              <div class="index-router-item"><span><i class="iconfont iconweidian"></i>微店信息</span> <router-link to="/home/shop">查看</router-link></div>
              <div class="index-router-item"><span><i class="iconfont iconshenbao"></i>项目信息</span> <router-link to="/home/projectList">查看</router-link></div>
            </div>
          </div>
          <div class="index-info-item">
            <div class="content-info-title">基本信息</div>
            <div class="index-router">
              <p>组织名称：{{name}}</p>
              <p>登记证号：{{regist_no}}</p>
              <p>统一社会组织代码：{{unified_code}}</p>
              <p>社会组织类型：{{org_type}}</p>
              <p>法定代表人/负责人：{{legal_person}}</p>
              <p>登记管理机关:{{administration}}</p>
              <p>业务主管单位：{{business_unit}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "user",
  data() {
    return {
      administration: '',
      business_unit: '',
      legal_person: '',
      name: '',
      org_type: '',
      regist_no: '',
      status: 1,
      unified_code: '',
    }
  },
  created() {
    this.$emit('setIndex', 4)
    this.init()
  },
  methods: {

    init() {
      this.$api.apiContent.userInfo({
        token: this.$store.state.user.token
      }).then(res => {
        this.administration = res.data.administration
        this.business_unit = res.data.business_unit
        this.legal_person = res.data.legal_person
        this.name = res.data.name
        this.org_type = res.data.org_type
        this.regist_no = res.data.regist_no
        this.status = res.data.status
        this.unified_code = res.data.unified_code
      })
    }
  }
}
</script>

<style scoped lang="scss">
.content-info {
  display: flex;
  flex-direction: column;
  min-height: 950px;
  .content-info-title {
    display: flex;
    flex-direction: row;
    height: 56px;
    line-height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    justify-content: space-between;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }
  }
  .step-box{
    padding:70px 50px;
    .speed-box{
      &:before{
        position: absolute;
        top: 85px;
        left: 70px;
        right: 70px;
        content: '';
        height: 9px;
        background-color: #ffffff;
      }
      &.active1{
        &:after{
          position: absolute;
          top: 85px;
          left: 70px;
          width: 10%;
          content: '';
          height: 9px;
          background-color: #f9aa0d;
        }
      }
      &.active2{
        &:after{
          position: absolute;
          top: 85px;
          left: 70px;
          width: 30%;
          content: '';
          height: 9px;
          background-color: #f9aa0d;
        }
      }
      &.active3{
        &:after{
          position: absolute;
          top: 85px;
          left: 70px;
          width: 70%;
          content: '';
          height: 9px;
          background-color: #f9aa0d;
        }
      }
      &.active4{
        &:after{
          position: absolute;
          top: 85px;
          left: 70px;
          right: 70px;
          width: auto;
          content: '';
          height: 9px;
          background-color: #f9aa0d;
        }
      }

      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 221px;
      padding: 40px;
      background-image: linear-gradient(0deg,
        #ffe7d2 0%,
        #fffaf5 100%);
      border-radius: 4px;
      border: solid 2px #ffe0c5;
      position: relative;
      .speed-item{
        width: 100px;
        z-index: 111;
        &.active{
          i{
            background: #f9aa0d;
            color: #fff;
          }
        }
        i{
          display: block;
          margin: 0 auto;
          width: 57px;
          height: 57px;
          text-align: center;
          line-height: 57px;
          font-size: 26px;
          color: #ffecdb;
          background-color: #ffffff;
          border-radius: 57px;
        }
        p{
          text-align: center;
          margin-top: 10px;
          line-height: 30px;
          font-size: 21px;
          color: #ffb576;
        }
      }
    }
    .index-info{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      .index-info-item{
        width: 48%;
        height: 397px;
        background-color: #ffffff;
        border-radius: 3px;
        border: solid 2px #e6e6e6;
        .index-router{
          padding: 40px 20px;
          .index-router-item{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 60px;
            padding-left: 20px;
            margin-bottom: 20px;
            background-color: #fff9f3;
            border-radius: 30px;
            border: solid 1px #ffe8d4;
            span{
              display: flex;
              align-items: center;
              font-size: 18px;
              color: #f9aa0d;
              i{
                margin-right: 5px;
                font-size: 20px;
              }

            }
            a{
              width: 87px;
              height: 60px;
              text-align: center;
              line-height: 60px;
              font-size: 18px;
              color: #fff;
              background-color: #f9aa0d;
              border-radius: 30px;
              border: solid 1px #ffe8d4;
            }

          }
          p{
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
